
import { defineComponent } from "vue";
import useOnShow from "@/composition/OnShow";

export default defineComponent({
  name: "ActiveLink",
  props: {
    text: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    navigate: {
      type: Function,
      required: true,
    },
  },
  setup() {
    return {
      show: useOnShow(),
    };
  },
});
